<script>
import { notify } from '@/helpers/notify' 

export default {
    name: 'PortModal',
    props:[
        "data",
        "modelOpen" 
    ],
    data() {
        return {
            form: {},
            portList:[{disport:'', icip:'', icport: '', protocol:'tcp'}],
            ports:[],
            submitted: false,
        };
    }, 
    watch:{
        modelOpen(){
            const { id } = this.data
            this.form = { id }
            this.portList=[{disport:'', icip:'', icport: '', protocol:'tcp'}],
            this.ports =[],

            this.getPorts()
        }
    },
    methods: {
        addLine(){
            this.portList.push({ disport:'', icip:'', icport: '', protocol:'tcp'})
        },
        getPorts(){
            this.$http.get(`/members/${this.form.id}/port-list`)
                    .then(response => this.ports = response.data)
        },
        handleSubmit(){
            this.$http.post(`/members/${this.form.id}/port-add`, { portlar:this.portList })
                    .then(response => {
                        this.getPorts()
                        if(response.data.error){
                            return notify.error(response.data.message)
                        }
                        notify.success(response.data.message)
                    })
        },
        close(){
            this.$parent.$bvModal.hide('port_modal')
        },
    },
};
</script>

<template>
<b-modal id="port_modal"  title="Port Yönlendirme" size="lg" no-close-on-backdrop hide-footer>
    <form @submit.prevent="handleSubmit">
        <div class="row mb-1">
            <div class="col">
                <div class="row mb-1" v-for="(port,i) in portList" :key="i">
                    <div class="col">
                        <input
                            id="amount" 
                            v-model="port.disport"
                            type="text"
                            class="form-control"
                            placeholder="Dış Port"
                        />
                    </div>
                    <div class="col">
                        <input
                            id="amount" 
                            v-model="port.icip"
                            type="text"
                            class="form-control"
                            placeholder="İç İp"
                        />
                    </div>
                    <div class="col">
                        <input
                            id="amount" 
                            v-model="port.icport"
                            type="text"
                            class="form-control"
                            placeholder="İç Port"
                        />
                    </div>
                    <div class="col">
                      <select class="form-select" v-model="port.protocol">
                        <option value="tcp">TCP</option>
                        <option value="udp">UDP</option>
                      </select>
                    </div>
                </div>
            </div>
          
            <label class="col-sm-3 text-end">
                <button type="button" class="btn btn-warning" @click.prevent="addLine">Satır Ekle</button>
            </label>
        </div>
        <div class="row d-flex flex-wrap mb-1">
            <div class="responsive-table">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Dış İp</th>
                            <th>İç İp</th>
                            <th>Dış Port</th>
                            <th>İç Port</th>
                            <th>Protocol</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(prt, i) in ports" :key="i">
                            <td>{{ prt.disip }}</td>
                            <td>{{ prt.icip }}</td>
                            <td>{{ prt.disport }}</td>
                            <td>{{ prt.icport }}</td>
                            <td>{{ prt.protocol }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
            <b-button variant="light" @click="close()">Vazgeç</b-button>
            <b-button 
                type="submit" 
                variant="success" 
                class="ms-1"
                >Ekle
            </b-button>
        </div>
    </form>
</b-modal>
</template>